module.exports = __webpack_public_path__ + "static/img/s9.38d0ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s9.png
// module id = +fZJ
// module chunks = 73